<template>
<div id="new-user" class="flex-c">
    <p>感谢您关注施维雅中国！</p>
    <p>Thank you for following Servier China Wechat account!</p>
    <p>40年前，带着来自法国的创新、憧憬和果敢，施维雅来到了中国——这个最具生命力和创新精神的国度，并扎根于此；与改革开放的中国共同开启了勇于探索、不惧风雨、砥砺前行的逐梦之旅。</p>
    <p>Forty years ago, Servier came to China from the other side of the world – France – with an innovative vision and aspiration, and established roots in this dynamic country. We have embarked on a journey of exploration and chased dreams in an open and reforming China.</p>
    <p>在这片热土上，施维雅中国有幸与几代中国医学人不负韶华，将青春和热情，铺就成中国慢性疾病防治管理的稳步向前；不断改进治疗手段，满足患者需求；为无数中国患者带来健康福祉。</p>
    <p>Servier China has had the honor of working with several generations of leaders, associations, healthcare professionals and partners to promote steady progress in chronic disease prevention and control in China. Our goal has been to meet patients’ needs with a commitment to therapeutic progress, and to bring health and well-being to more Chinese patients.</p>
    <p>40年，从一个婴儿成长为壮年，脱去莽撞、初心不改；施维雅中国经过长期的努力、沉淀和积累，施维雅中国睿智沉稳、意气风发。</p>
    <p>Over the past four decades, Servier China has grown from an early entrant to maturity after years of effort and the accumulation of experience. We still follow our original patient-centric vision and regard innovation as the driving force for our sustainable development.</p>
    <p>携手共进、开拓明天。施维雅人是一群富有热情的人，正以创业激情为我们的使命而服务。将创新是促进施维雅中国不断发展的动力源泉和策略重点，施维雅中国将继续关爱我们的患者、专业医护人员以及员工。</p>
    <p>We are a group of enthusiastic individuals with an entrepreneurial passion to serve our vocation, and work together for an even better tomorrow. Innovation is the driving force and strategic focus for Servier China‘s continuous development. Servier CHINA will continue to work hard to care for Patients, for Doctors and for Employees.</p>
    <video src="http://7n.m-visitor.medsci.cn/new_user.mp4" controls preload="auto" class="flex-self-ctr" width="100%">
    </video>
    <div class="flex-r flex-ctr wrap">
        <div class="flex-self-ctr menu">
            <span>施行速报</span>
            <span>维系健康</span>
            <span>迩见知雅</span>
        </div>
    </div>
    <van-image class="logo flex-self-ctr" :src="logoGif"></van-image>
    <p class="footer">搜索“<em>施维雅中国</em>”关注我们</p>
</div>
</template>

<script>
export default {
    data() {
        return {
            logoGif: require('@/assets/logo.gif')
        }
    },
    created() {},
    methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#new-user {
    padding: 28px 20px;
    p {
        font-size: $font-size;
        line-height: $line-height;
        margin-bottom: $margin-btm;
    }
    .wrap{
        height: 120px;
        .menu{
            span{
                padding-right: 15px;
                margin-right: 20px;
                border-right: 1PX solid #4a4a4a;
            }
        }
    }
    .logo{
        width: 100%;
        height: auto;
    }
    .footer{
        text-align: center;
        em{
            font-style: normal;
            color: $color-blue;
        }
    }
}
</style>
